module.exports = __webpack_public_path__ + "intuit-card-bottom-right.2NP6vsSn.png";